import styled from "styled-components";
import { DESKTOP_MEDIA_QUERY } from "../constants";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ButtonInner = styled.div`
  width: 243px;
  height: 59px;
  line-height: 59px;
  border-radius: 45px;
  background-color: ${({ light }) => (light ? "#fff" : "#0000ff")};
  font-size: 31px;
  font-weight: 700;
  color: ${({ light }) => (!light ? "#fff" : "#0000ff")};
  text-align: center;
  text-transform: uppercase;

  ${DESKTOP_MEDIA_QUERY} {
    width: 370px;
    height: 90px;
    line-height: 90px;
    font-size: 50px;
    cursor: pointer;
  }
`;
